module.exports = __webpack_public_path__ + "img/carmain.342a5f41.png";